
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Itrequestform from './Itrequestform';
import Footer from './Footer';
import DocumentEnergyBanner from './DocumentEnergyBanner';
import DocumentAutotabtwo from './DocumentAutotabtwo';
import Dropdowndata from './Dropdowndata';
import DocumnentCommuniTabone from './DocumnentCommuniTabone';
import DocumentEnrgytabone from './DocumentEnrgytabone';
import DocumentCommunicationBanner from "./DocumentCommunicationBanner";
import DocumnetComunicationTabtwo from "./DocumnetComunicationTabtwo";


const DocumentCommunicationPage = () => {
  const location = useLocation();

  const firstContentRef = useRef(null); // Reference for the first content (DocumnetAutotabone)
  const secondContentRef = useRef(null); // Reference for the second content (DocumentAutotabtwo)



  
  // Function to scroll to the first content dynamically
  const scrollToFirstContent = () => {
    if (firstContentRef.current) {
      const offset = 100;
      const elementPosition = firstContentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };
  
  // Function to scroll to the second content dynamically
  const scrollToSecondContent = () => {
    if (secondContentRef.current) {
      const offset = 100;
      const elementPosition = secondContentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  // The useEffect to handle hash-based scroll
  useEffect(() => {
    if (location.hash === "#documentCommunicationPageSEeconddata") {
      setTimeout(() => {
        scrollToSecondContent();
      }, 500); // Delay ensures smooth scrolling after page load
    } else if (location.hash === "#documentCommunicationPageone") {
      setTimeout(() => {
        scrollToFirstContent();
      }, 500); // Delay ensures smooth scrolling after page load
    }
  }, [location]); // Re-run when location (URL) changes

  return (
    <div style={{ background: '#fff' }}>
     <DocumentCommunicationBanner />

      <div ref={firstContentRef} id="documentCommunicationPageone" className="margin-top-adjustment">
      <DocumnentCommuniTabone />
      </div>

      <div ref={secondContentRef} id="documentCommunicationPageSEeconddata" className="margin-top-adjustment">
      <DocumnetComunicationTabtwo />
      </div>

      <br />
      <Itrequestform />

      <div className="page-footer" style={{ marginTop: "-60px" }}>
        <Footer />
      </div>

      {/* <style>
        {`
          h1,h2,h3,h4,h5,h6,p {
            font-family: urbanist, serif;
          }
        `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  );
}

export default DocumentCommunicationPage;
